import { ContactRequestErrorCode } from './errorCodes';

export const contactRequestErrorMessages: Record<
  ContactRequestErrorCode,
  string
> = {
  [ContactRequestErrorCode.NETWORK_ERROR]:
    'Błąd sieci. Sprawdź połączenie i spróbuj ponownie.',
  [ContactRequestErrorCode.FORBIDDEN]:
    'Brak uprawnień do wykonania tej operacji.',
  [ContactRequestErrorCode.UNAUTHORIZED]:
    'Brak uprawnień do wykonania tej operacji.',
  [ContactRequestErrorCode.NOT_FOUND]: 'Zgłoszenie nie zostało znalezione.',
  [ContactRequestErrorCode.INVALID_TRANSITION]:
    'Przejście do wybranego statusu jest niedozwolone. Odśwież stronę i spróbuj ponownie.',
  [ContactRequestErrorCode.VALIDATION_ERROR]: 'Nieprawidłowe dane formularza.',
  [ContactRequestErrorCode.UNKNOWN]:
    'Nie udało się wykonać operacji. Spróbuj ponownie.',
  [ContactRequestErrorCode.UNEXPECTED_ERROR]:
    'Wystąpił nieoczekiwany błąd. Spróbuj ponownie.',
};
